<template>
<div>
  <div id="hw-hero">
    <headerSite></headerSite>
    <sliderSite></sliderSite>
  </div>
  <section class="pricingtables">
    <div class="row no-gutter">
      <div class="panel panel-info">
        <div>
          <h2>Você já é cadastrado? Realize seu <a href="https://app.horabela.com.br/login">login</a>.</h2>
          <h2>Ainda não! <a href="https://app.horabela.com.br/registro">Cadastre-se agora</a> </h2>
        </div>
      </div>
    </div>
  </section>
  <section class="features">
    <div class="row">
      <div class="col-md-4">
        <h3>Benefícios</h3>
        <div class="feature">
          <div class="featureicon">
            <span class="typcn typcn-business-card"></span>
          </div>
          <h5>Gestão de Comandas</h5>
          <p>Criação e finalização de comandas com poucos cliques<br />
          Registro de serviços, produtos e formas de pagamento<br />
          Histórico completo por cliente<br />
          Relatórios financeiros por período, profissional ou serviço</p>
        </div>
        <div class="feature">
          <div class="featureicon">
            <span class="typcn typcn-calendar"></span>
          </div>
          <h5>Agendamento Online Inteligente</h5>
          <p>Link direto para agendar via redes sociais ou WhatsApp<br />
            Horários disponíveis em tempo real<br />
            Sem necessidade de aplicativo<br />
            Redução de faltas</p>
        </div>
        <div class="feature">
          <div class="featureicon">
            <span class="typcn typcn-cog-outline"></span>
          </div>
          <h5>Configure seus horários e serviços</h5>
          <p>Você pode fornecer as informações do estabelecimento para sua página ficar bem apresentável e contendo as 
            informações importantes, você também pode configurar seus horários disponíveis e serviços prestados para 
            personalizar sua agenda.</p>
        </div>
      </div>
      <div class="col-md-8">
        <img src="/main-site/images/features-img.jpg" alt />
      </div>
    </div>
  </section>
  <featuresSite></featuresSite>
  <pricingSite></pricingSite>  
  <formRegister></formRegister>
  <footerSite></footerSite>
  <a href="#top" id="back-to-top">
    <i class="fa fa-angle-up"></i>
  </a>
</div>
</template>

<script>
import footerSite from './template/footer'
import headerSite from './template/header'
import sliderSite from './template/slider'
import pricingSite from './template/pricing'
import featuresSite from './template/features'

export default {
  components: {
    footerSite,
    headerSite,
    sliderSite,
    pricingSite,
    featuresSite,
  }
};
</script>

<style scoped>
</style>